import React from 'react';
import * as R from 'ramda';
import ServicesUploading from '../../../../../assets/images/placeholder/ServicesUploading-ilustration.png';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {setCompletedServiceDataFilling} from '../../../../../actions/facilita-api';
import * as Loadings from '../../../../../constants/loadings/facilita/deathDeclaration';

export const EmptyState = ({user, isLoading}) => {
    const dispatch = useDispatch();
    const history = useHistory();

    if(R.isNil(user)){
        return "";
    }

    return (
        <article className="block flex-column h-100">
            <h3 className="sr-only visually-hidden">Finished setup</h3>
            <div className="container container-screen text-center my-auto px-xl-5">
                <img className="img-fluid mx-auto mb-3 mt-4" src={ServicesUploading} alt="Services Uploading" />
                <div className="h2 font-weight-semi mb-4">Vous avez finalisé le dossier de {user.firstName} {user.lastName}.<br/>
                    Vous pouvez dès à présent : déposer l'acte de décès, confirmer et valider les informations transmises afin que les courriers soient créés et envoyés.
                </div>
            </div>
            <div className="container container-screen text-center mt-auto">
                {
                    isLoading.includes(Loadings.COMPLETING_USER_SERVICES_DATA) ? 
                        <button type="button" className="btn btn-info loading-btn show"><div className="loading loading-spinner spinner-border spinner-border-sm mr-2"></div>Accéder à la déclaration de décès</button>
                    :
                        <button type="button" className="btn btn-info" onClick={()=>{
                            dispatch(setCompletedServiceDataFilling(user.id))
                            .then(() => {
                                window.location = `/facilita/${user.id}/declarer/step1`;
                            });
                        }}>Accéder à la déclaration de décès</button>
                }
                
            </div>

        </article>
    )
}